const SPANISH_STANDARDS = {
  "Spanish": {
    "K-2": {
      "Listening": [],
      "Speaking": []
    },
    "3-5": {
      "Reading": [],
      "Writing": [],
      "Listening": [],
      "Speaking": [],
      "Culture & Civilization": []
    },
    "6-8": {
      "Reading": [],
      "Writing": [],
      "Listening": [],
      "Speaking": [],
      "Grammar & Vocabulary": [],
      "Culture & Civilization": []
    },
    "High School": {
      "Reading": [],
      "Writing": [],
      "Listening": [],
      "Speaking": [],
      "Grammar & Vocabulary": [],
      "Culture & Civilization": []
    }
  }
};

export default SPANISH_STANDARDS;
